export const replaceWindowPositions = (idToId, json) => {
    let replaced = {};
    for (let key in json) {
        replaced[idToId[key] || key] = json[key];
    }
    return replaced;
};

export const replaceInletIds = (idToId, json) => {
    let replaced = {};
    for (let key in json) {
        let newKey = replace(idToId, key);
        let list = [];
        for (let element of json[key]) {
            let connection = {};
            for (let _key in element) {
                connection[_key] = replace(idToId, element[_key]);
            }
            list.push(connection);
        }
        replaced[newKey] = list;
    }
    return replaced;
};

const replace = (idToId, key) => {
    let tokens = key.split('.');
    if (tokens.length === 1) {
        return idToId[tokens[0]] || key;
    }
    return tokens[0] + '.' + idToId[tokens[1]];
};
